module.exports = __webpack_public_path__ + "files/b6444c970a7d028f525ca7b32c97ba4b.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-144x144.png
// module id = 750
// module chunks = 27